import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=791114e1&scoped=true&"
import script from "./ChatBubble.vue?vue&type=script&lang=ts&"
export * from "./ChatBubble.vue?vue&type=script&lang=ts&"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=791114e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791114e1",
  null
  
)

export default component.exports